import { render } from "./LivePlayer.vue?vue&type=template&id=fd5e4a98"
import script from "./LivePlayer.vue?vue&type=script&lang=js"
export * from "./LivePlayer.vue?vue&type=script&lang=js"

import "./LivePlayer.vue?vue&type=style&index=0&id=fd5e4a98&lang=less"

import exportComponent from "E:\\lcz\\WX.Unify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__